$(function(){
  /* -- Header Logo Swap ---------- */
  if ($('.base-logo').length > 1) {
    const maxLogo = $('.base-logo').length;
    const timer = (maxLogo == 2) ? 2000 : 900;
    let current = 0;

    setInterval(function() {
      current = (current >= maxLogo) ? 1 : current + 1;

      $('.base-logo').removeClass('visible');
      $('#logo-' + current).addClass('visible');
    }, timer);
  }

  /* -- Responsive Menu Trigger ---------- */
  $('.hamburger, .close-menu').on('click', function() {
    $('.mobile-nav').toggleClass('active');
  });

  /* -- Product Info panels ---------- */
  $('.product-info-panel strong').on('click', function() {
    $('.product-info-panel .info').not($(this).next('.info')).slideUp();
    $(this).next('.info').slideToggle();
  });

  /* -- Cookie Logic ---------- */
  if (!getCookie('cookie-wall') || getCookie('cookie-wall') === '') {
    $('.cookie-banner').addClass('active');
  }

  $('#close-cookie').on('click', function() {
    $('.cookie-banner').removeClass('active');
    setCookie('cookie-wall', 'true', '1');
  });

  /* Newsletter Pop-up */
  $('.newsletter__btn__content').on('click', function() {
    $('.newsletter__pop__up').toggleClass('show__popup')
    $('.newsletter__btn').addClass('hide__self');
  })
  $('.newsletter__pop__up .btn__close').on('click', function() {
    $('.newsletter__pop__up').toggleClass('show__popup');
    $('.newsletter__btn').removeClass('hide__self');
  })
  $('.newsletter__btn .btn__close').on('click', function() {
    $('.newsletter__btn').addClass('hide__self');
  })
});

/* == HELPERS
======================================== */
// setCookie('test', '1', '1'); //(key,value,expiry in days)
function setCookie(key, value, expiry) {
  var expires = new Date();
  expires.setTime(expires.getTime() + (expiry * 24 * 60 * 60 * 1000));
  document.cookie = key + '=' + value + ';path=/' + ';expires=' + expires.toUTCString();
}
// getCookie('test');
function getCookie(key) {
  var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
  return keyValue ? keyValue[2] : null;
}
// eraseCookie('test');
function eraseCookie(key) {
  var keyValue = getCookie(key);
  setCookie(key, keyValue, '-1');
}


